/**
 * Create by zhayuechao on 2018/08/15
 * 处理查询数据
 */
// 顾客类型

'use strict'

import store from './store'
import * as way from './way'
import Highcharts from 'highcharts'
const log = console.log.bind(console)
// 过滤空数据
let filterType = (data) => {
    if (typeof data === 'string' && !data) {
        return false
    } else if (
        typeof data === 'object' &&
        Object.prototype.toString.call(data) === '[object Null]'
    ) {
        return false
    } else if (data === false) {
        return false
    } else if (typeof data === 'undefined') {
        return false
    } else {
        return true
    }
}

// 表头信息公用
// 查询
let setQuery = (valObj, clearCompare, noneTime) => {
    // console.log(valObj, clearCompare, noneTime)
    log('on set query common')
    noneTime = noneTime || 0
    if ((valObj.startTime && valObj.endTime) || noneTime) {
        if (!clearCompare) {
            clearCompare = {}
        }
        store.state.query_common = Object.assign(
            {},
            store.state.query_common,
            clearCompare,
            valObj
        )
        store.commit({
            type: 'setQueryCommon',
            data: removeDataNull(store.state.query_common),
        })
        // console.log(store.state.query_common, 7)
    } else {
        store.state.query_common = Object.assign(
            {},
            store.state.query_common,
            valObj
        )
        store.commit({
            type: 'setQueryCommon',
            data: removeDataNull(store.state.query_common),
        })
    }
}

// 查询条件去空
let removeDataNull = (global) => {
    Object.keys(global).forEach((item) => {
        if (typeof global[item] === 'object' && !global[item]) {
            delete global[item]
        }
    })
    return global
}

// 查询表格
let setQueryTable = (valObj) => {
    store.state.query_table = Object.assign({}, store.state.query_table, valObj)
    store.commit({
        type: 'setQueryTable',
        data: store.state.query_table,
    })
}

// 查询表格数据 和 chart
let getQueryAll = (queryData) => {
    // log('queryData', queryData)
    store.commit({
        type: 'setQueryData',
        data: queryData || {},
    })
    store.commit({
        type: 'setQueryTable',
        data: queryData || {},
    })
    store.commit('initNoData')
}

// 选择获取下拉顾客类型
let setQueryCustomer = (customerClass, val) => {
    let query = {}
    if (typeof customerClass[val[0]].children === 'undefined') {
        query = {
            isOld: customerClass[val[0]].isOld,
            customerType: customerClass[val[0]].customerType,
        }
    } else {
        query = {
            customerType: customerClass[val[0]].children[val[1]].customerType,
            isOld: customerClass[val[0]].children[val[1]].isOld,
        }
    }
    return query
}

// 选择获取下拉客流渠道
let setQueryPassFlow = (pass, val) => {
    let query = {}
    if (typeof pass[val[0]].children === 'undefined') {
        query = {
            customerChannel: pass[val[0]].customerChannel,
        }
    } else {
        query = {
            customerChannel: pass[val[0]].children[val[1]].customerChannel,
        }
    }
    return query
}

// 比较表格  目标与增长
let setApiCompareToTable = (res, sort, sIndex, title) => {
    // console.log(res, sort, sIndex, title);
    // sortIndex = (sortIndex === 'names') ? 'name' : sortIndex
    let result = res.data.data
    let twoLevel = []
    let oneLevel = []
    let header = result.tableHeaders

    if (typeof header[0] === 'object') {
        header.forEach((item) => {
            twoLevel.push(item.indicatorNames)
            oneLevel.push(item.classifyName)
        })
    } else {
        twoLevel = header
        header.map((item, i) => {
            if (item.indexOf('占比') !== -1) {
                arr.push(i)
            }
        })
    }
    // 如果数据为空，直接返回
    if (!result.tableData.data.length) {
        return Object.assign({}, result, {
            oneLevel: oneLevel,
            twoLevel: twoLevel,
            levelTitle: [].concat.apply([], twoLevel),
            count: result.tableData.elementCount,
            size: result.tableData.size,
            pagecount: result.tableData.pageCount,
        })
    }
    let sum1 =
        result.tableData.data[result.tableData.data.length - 1].mergeData[0][1]
    let sum2 =
        result.tableData.data[result.tableData.data.length - 1].mergeData[1][1]
    let arr = []
    result.tableData.data.forEach((item) => {
        item.mergeData.forEach((str, index) => {
            if (str === null) {
                item.mergeData.splice(index, 1)
            }
        })
    })
    // 计算占比
    if (arr.length) {
        arr.forEach((i) => {
            result.tableData.data.forEach((item) => {
                if (sum1 !== 0) {
                    if (item.mergeData[0][i] !== 0) {
                        item.mergeData[0][i + 1] =
                            ((item.mergeData[0][i] / sum1) * 100).toFixed(1) +
                            '%'
                    }
                }
                if (sum2 !== 0) {
                    if (item.mergeData[1][i] !== 0) {
                        item.mergeData[1][i + 1] =
                            ((item.mergeData[1][i] / sum2) * 100).toFixed(1) +
                            '%'
                    }
                }
            })
        })
    }
    if (result.tableData.data) {
        if (title !== '日期' && title !== '时间分布' && title !== '星期分布') {
            if (
                typeof result.tableData.data[0].mergeData === 'object' &&
                result.tableData.data[0].mergeData
            ) {
                // if (typeof sortIndex === 'number') {
                result.tableData.data.sort(
                    way.sortCompareData(sIndex, 'mergeData', 'descend')
                )
                // } else {
                //   tableData.tableData.data.sort(way.sort(sortIndex, 'descend'))
                // }
            }
        }
    }
    let aa = ''
    aa = sort === 0 ? 'icon-ion-arrow-down-a' : 'icon-ion-arrow-up-a'
    let bb = ['', '', '', '', '', '', '', '', '', '', '', '', '', '']
    bb[sIndex - 1] = aa
    return Object.assign({}, result, {
        oneLevel: oneLevel,
        twoLevel: twoLevel,
        levelTitle: [].concat.apply([], twoLevel),
        count: result.tableData.elementCount,
        size: result.tableData.size,
        pagecount: result.tableData.pageCount,
        devsort: bb,
    })
}

// 处理表格数据 二级表头    xxx概况
let setApiDataToTable = (res, sort, sIndex, title) => {
    // 排序问题
    log('setApiDataToTable')
    // console.log("处理数据=》", res);
    let tableData = res.data.data
    // console.log(res, sort, sIndex, title);
    // 一级标题
    let oneLevel = []
    // 二级标题
    let twoLevel = []
    let header = tableData.tableHeaders
    let sum = []
    let arr = []
    if (typeof tableData.tableHeaders[0] === 'object') {
        tableData.tableHeaders.forEach((item) => {
            twoLevel.push(item.indicatorNames || '')
            oneLevel.push(item.classifyName)
        })
    } else {
        twoLevel = tableData.tableHeaders
        header.map((item, i) => {
            if (item.indexOf('占比') !== -1) {
                arr.push(i)
            }
        })
    }
    arr.forEach((item, i) => {
        let y = 0
        tableData.tableData.data.forEach((ele, j) => {
            ele.noCompareData.forEach((it, x) => {
                if (x === item - 1) {
                    y += it
                }
            })
        })
        sum.push(y)
    })
    // log(JSON.stringify(tableData.tableData.data, null, 4) )
    // log('--------------------------------------------')
    // 这段代码会改变 “当前汇总” 中的数据
    if (arr.length) {
        arr.forEach((ele, i) => {
            tableData.tableData.data.forEach((item) => {
                if (item.noCompareData[ele - 1] !== 0 && sum[i] !== 0) {
                    // log('changechangechangechangechangechangechangechangechangechange')
                    // log(JSON.stringify(item, null, 4) )
                    let value = (
                        (item.noCompareData[ele - 1] / sum[i]) *
                        100
                    ).toFixed(1)
                    item.noCompareData[ele] = value + '%'
                }
            })
        })
    }
    // log(JSON.stringify(tableData.tableData.data, null, 4) )
    // 去除：理疗师图标 sortIndex -2 操作
    if (tableData.tableData.data.length !== 0) {
        // 首次请求，理疗师会分页，后端排序，其他，前端排序
        if (tableData.tableData.data.length <= 20) {
            let c = tableData.tableData.data[0].noCompareData
            if (typeof c === 'object' && c) {
                // if (
                //     title === '活动名称' ||
                //     title === '优惠券名称' ||
                //     title === '积分商品名称'
                // ) {
                //     log('if')
                //     tableData.tableData.data.sort(
                //         way.sortObjectData(
                //             sIndex - 1,
                //             'noCompareData',
                //             'descend'
                //         )
                //     )
                // } else {
                log('else')
                tableData.tableData.data.sort(
                    way.sortObjectData(sIndex - 1, 'noCompareData', 'descend')
                )
                // }
            }
        } else {
        }
    } else {
        let length =
            tableData.tableHeaders.length *
            tableData.tableHeaders[0].indicatorNames.length
        tableData.tableData.data = [
            { noCompareData: new Array(length).fill('--') },
        ]
        // console.log(tableData.tableData.data)
    }
    let aa = ''
    aa = sort === 0 ? 'icon-ion-arrow-down-a' : 'icon-ion-arrow-up-a'
    let bb = ['', '', '', '', '', '', '', '', '', '', '', '', '', '']
    bb[sIndex - 1] = aa
    // log('sort----------------')
    // log(JSON.stringify(bb, null, 4) )
    // log('sort----------------')
    let result = Object.assign({}, tableData, {
        oneLevel: [].concat.apply([], oneLevel),
        twoLevel: twoLevel,
        twoTitle: [].concat.apply([], twoLevel),
        count: res.data.data.tableData.elementCount,
        size: res.data.data.tableData.size,
        pageNum: res.data.data.tableData.pageCount,
        devsort: bb,
    })
    return result
}

// 比较表格  销售趋势
let setApiDataToTableCommon = (res, ascending, sIndex, title) => {
    try {

    // sortIndex = sortIndex || 0
    console.log(res, ascending, sIndex, title)
    if (!filterType(res)) return false
    if (store.state.query_common.compareType) {
        return {}
    }
    // 自定义维度的表还有占比的，前端计算
    const result = res.data.data
    // 一级标题
    let oneLevel = []
    // 二级标题
    let twoLevel = []
    let tableList = []
    let header = result.tableHeaders
    if (filterType(result.tableData)) {
        result.tableData.data.forEach((item, index) => {
            tableList.push(result.tableData.data[index].noCompareData)
        })
    }
    let sum = []
    let arr = []
    if (typeof header[0] === 'object') {
        header.forEach((item, i) => {
            twoLevel.push(item.indicatorNames)
            oneLevel.push(item.classifyName)
        })
    } else {
        twoLevel = header
        header.map((item, i) => {
            if (item.indexOf('占比') !== -1) {
                arr.push(i)
            }
        })
    }
    arr.forEach((item, i) => {
        let y = 0
        result.tableData.data.forEach((ele, j) => {
            if (ele.name !== '当前汇总') {
                ele.noCompareData.forEach((it, x) => {
                    if (x === item - 1) {
                        y += it
                    }
                })
            }
        })
        sum.push(y)
    })
    if (arr.length) {
        arr.forEach((ele, i) => {
            result.tableData.data.forEach((item) => {
                if (item.noCompareData[ele - 1] !== 0 && sum[i] !== 0) {
                    // console.log(item.noCompareData[ele - 1], sum[i]);
                    item.noCompareData[ele] =
                        ((item.noCompareData[ele - 1] / sum[i]) * 100).toFixed(
                            1
                        ) + '%'
                }
            })
        })
    }
    let aa = ''
    aa = ascending === 0 ? 'icon-ion-arrow-down-a' : 'icon-ion-arrow-up-a'
    let bb = ['', '', '', '', '', '', '', '', '', '', '', '', '', '']
    if (filterType(result.tableData)) {
        // 门店和时间共用，门店后端默认没有排序，自己排序，变化也是前端排序，日期的默认有排序，也变化也调取后端
        if (result.tableData.data) {
            if (
                typeof result.tableData.data[0].noCompareData === 'object' &&
                result.tableData.data[0].noCompareData.length
            ) {
                if (title !== '日期') {
                    if (ascending === 0) {
                        result.tableData.data.sort(
                            way.sortData(
                                sIndex - 1,
                                'noCompareData',
                                'descend',
                                title
                            )
                        )
                    } else {
                        result.tableData.data.sort(
                            way.sortData(
                                sIndex - 1,
                                'noCompareData',
                                'ascend',
                                title
                            )
                        )
                    }
                }
                bb[sIndex - 1] = aa
            }
        }
        return Object.assign({}, result, {
            tableList: tableList,
            oneLevel: oneLevel,
            twoLevel: twoLevel,
            levelTitle: [].concat.apply([], twoLevel),
            count: res.data.data.tableData.elementCount,
            size: res.data.data.tableData.size,
            pagecount: res.data.data.tableData.pageCount,
            devsort: bb,
        })
    } else {
        bb[sIndex - 1] = aa
        return Object.assign({}, result, {
            tableList: [[0]],
            oneLevel: oneLevel,
            twoLevel: twoLevel,
            levelTitle: [].concat.apply([], twoLevel),
            count: 0,
            size: 0,
            pagecount: 0,
            devsort: bb,
        })
    }

    }catch(e){
        console.error(e)
    }
}
// 无维度表格，优惠券分析漏斗转化
let setApiDataTonoDemesion = (res, ascending, sIndex, title) => {
    // sortIndex = sortIndex || 0
    // console.log(res, ascending, sIndex, title);
    if (!filterType(res)) return false
    if (store.state.query_common.compareType) {
        return {}
    }
    // 自定义维度的表还有占比的，前端计算
    const result = res.data.data
    // 一级标题
    let oneLevel = []
    // 二级标题
    let twoLevel = []
    let tableList = []
    let header = result.tableHeaders
    if (filterType(result.tableData)) {
        result.tableData.data.forEach((item, index) => {
            tableList.push(result.tableData.data[index].noCompareData)
        })
    }
    let arr = []
    if (typeof header[0] === 'object') {
        header.forEach((item, i) => {
            twoLevel.push(item.indicatorNames)
            oneLevel.push(item.classifyName)
        })
    } else {
        twoLevel = header
        header.map((item, i) => {
            if (item.indexOf('占比') !== -1) {
                arr.push(i)
            }
        })
    }

    return Object.assign({}, result, {
        tableList: tableList,
        oneLevel: oneLevel,
        twoLevel: twoLevel,
        levelTitle: [].concat.apply([], twoLevel),
        count: res.data.data.tableData.elementCount,
        size: res.data.data.tableData.size,
        pagecount: res.data.data.tableData.pageCount,
    })
}
// 自定义维度
let setApiNormalToTable = (res) => {
    // console.log(res);
    // 自定义维度的表还有占比的，前端计算
    const result = res.data.data.tableData
    let sum = []
    let header = res.data.data.tableHeaders
    let arr = []
    header.map((item, i) => {
        if (item.indexOf('占比') !== -1) {
            arr.push(i)
        }
    })
    arr.forEach((ele) => {
        result.data[result.data.length - 1].noCompareData.forEach(
            (item, index) => {
                if (index === ele - 1) {
                    sum.push(item)
                }
            }
        )
    })
    if (arr.length && sum !== 0) {
        arr.forEach((ele, i) => {
            result.data.forEach((item) => {
                if (item.noCompareData[ele - 1] !== 0 && sum[i] !== 0) {
                    // console.log(item.noCompareData[ele - 1]);
                    item.noCompareData[ele] =
                        ((item.noCompareData[ele - 1] / sum[i]) * 100).toFixed(
                            1
                        ) + '%'
                    // console.log(item.noCompareData[i])
                }
            })
        })
    }
    result.data.sort(way.sortData(0, 'noCompareData', 'descend'))
    return {
        tableData: result,
        twoTitle: [].concat.apply([], res.data.data.tableHeaders),
        count: result.elementCount,
        size: result.size,
        pagecount: result.pageCount,
        devsort: result.data ? ['icon-ion-arrow-down-a'] : [],
    }
}

// 目标与增长
let setTwoSerise = (result) => {
    let twoLevel = []
    let series = []
    result.yaxislist.forEach((item) => {
        series.push({
            name: item.name,
            type: item.gpType,
            data: item.value,
        })
        twoLevel.push(item.unit)
    })
    let y = [...new Set(twoLevel)]
    if (y.length === 2) {
        result.yaxislist.forEach((item, index) => {
            if (item.unit === y[2]) {
                series.splice(index, 1, {
                    name: item.name,
                    type: item.gpType,
                    data: item.value,
                    yAxis: 1,
                })
            }
        })
    }
    let yAxis = []
    y.forEach((item, index) => {
        yAxis.push({
            labels: {
                format: '{value}',
                style: {
                    color: Highcharts.getOptions().colors[index],
                },
            },
            title: {
                text: item,
                style: {
                    color: Highcharts.getOptions().colors[index],
                },
            },
            opposite: !!index,
        })
    })

    return {
        xAxis: result.xaxis,
        series: series,
        yAxis: yAxis,
    }
}

let noneValue = function (result) {
    for (let i = 0; i < result.length; i++) {
        console.log('result[i].value=>', result[i].value)
        if (result[i].value) {
            return true
        }
    }
    return false
}

// 饼图
let setPieSerise = (result) => {
    let series = []
    if (noneValue(result)) {
        // result.sort(way.sort('value', 'descend'))
        result.forEach((item) => {
            // console.log(item);
            series.push([item.name, item.value])
        })
    }
    return series
}

// 理疗师对比
let setCloumn = (result) => {
    let series = []
    let y = []
    let yAxis = []
    if (filterType(result)) {
        if (filterType(result.xaxis) && filterType(result.yaxislist)) {
            result.yaxislist.forEach((item) => {
                series.push({
                    name: item.name,
                    data: item.value,
                    type: item.gpType,
                })
                y.push(item.unit)
            })
            y = [...new Set(y)]
            if (y.length === 2) {
                result.yaxislist.forEach((item, index) => {
                    if (item.unit === y[1]) {
                        series.splice(index, 1, {
                            name: item.name,
                            type: item.gpType,
                            data: item.value,
                            yAxis: 1,
                        })
                    }
                })
            }
            y.forEach((item, index) => {
                yAxis.push({
                    labels: {
                        formatter: function () {
                            return item === '百分比'
                                ? `${this.value} %`
                                : `${this.value}`
                        },
                        style: {
                            color: Highcharts.getOptions().colors[index],
                        },
                    },
                    title: {
                        text: item,
                        style: {
                            color: Highcharts.getOptions().colors[index],
                        },
                    },
                    opposite: !!index,
                })
            })
            return {
                xAxis: {
                    minPadding: 0,
                    // startOnTick: false,
                    // endOnTick: false,
                    categories: result.xaxis,
                    crosshair: true,
                    tickInterval: 1,
                },
                series: series,
                yAxis: yAxis,
            }
        }
    } else {
        return {}
    }
}

// 销售趋势
let setTrendSerise = (result, cross) => {
    log('调用了销售趋势')
    cross = cross || false
    let series = []
    let y = []
    let yAxis = []
    let util = {}
    if (filterType(result)) {
        if (filterType(result.xaxis) && filterType(result.yaxislist)) {
            result.yaxislist.forEach((item, index) => {
                series.push({
                    name: item.name,
                    data: item.value,
                    type: item.gpType,
                })
                util[item.name] = item.unit === '百分比' ? '%' : ''
                y.push(item.unit)
            })
            y = [...new Set(y)]
            if (y.length === 2) {
                result.yaxislist.forEach((item, index) => {
                    if (item.unit === y[1]) {
                        series.splice(index, 1, {
                            name: item.name,
                            type: item.gpType,
                            data: item.value,
                            yAxis: 1,
                        })
                    }
                })
            }
            y.forEach((item, index) => {
                yAxis.push({
                    labels: {
                        formatter: function () {
                            return item === '百分比'
                                ? `${this.value} %`
                                : `${this.value}`
                        },
                        style: {
                            color: Highcharts.getOptions().colors[index],
                        },
                    },
                    title: {
                        text: item,
                        style: {
                            color: Highcharts.getOptions().colors[index],
                        },
                    },
                    opposite: !!index,
                })
            })
            return cross
                ? {
                      xAxis: {
                          minPadding: 0,
                          startOnTick: false,
                          endOnTick: false,
                          value: result.xaxis,
                          labels: {
                              // useHTML: true, // 加了useHTML弹出层的z-index值就会小于标签的z-index值
                              formatter: function () {
                                  let labelVal
                                  // console.log(this.value, result.xaxis.length, 45)
                                  if (this.value >= result.xaxis.length) {
                                      labelVal =
                                          result.xaxis[result.xaxis.length - 1]
                                  } else {
                                      labelVal = result.xaxis[this.value]
                                  }
                                  let reallyVal = labelVal
                                  if (reallyVal.length > 10) {
                                      reallyVal = labelVal.substr(0, 10) + '...'
                                  }
                                  return `<a title = ${labelVal}>${reallyVal}</a>`
                              },
                              style: {
                                  cursor: 'pointer',
                              },
                          },
                          crosshair: {
                              width: 1,
                              color: '#c7d8e6',
                              dashStyle: 'Solid',
                          },
                          // tickmarkPlacement: 'start',
                          tickInterval:
                              result.xaxis.length <= 10
                                  ? 1
                                  : Math.round(result.xaxis.length / 10),
                      },
                      series: series,
                      yAxis: yAxis,
                      util: util,
                  }
                : {
                      xAxis: {
                          categories: result.xaxis,
                          // tickInterval: result.xaxis.length <= 10 ? 1 : Math.round(result.xaxis.length / 10)
                          tickInterval: 1,
                      },
                      series: series,
                      yAxis: yAxis,
                      util: util,
                  }
        }
    } else {
        return {}
    }
}

// 饼图 + 趋势 --> 趋势
let setTrendColumn = (result) => {
    let series = []
    let y = []
    let yAxis = []
    let util = {}
    if (filterType(result)) {
        if (filterType(result.xaxis) && filterType(result.yaxislist)) {
            let t = 0
            result.yaxislist.forEach((item, index) => {
                if (item.value.length > 1) {
                    t = item.value.reduce((item, value, index) => item + value)
                }
                series.push({
                    name: item.name,
                    data: item.value,
                    type: item.gpType,
                    total: t,
                })
                util[item.name] = item.unit === '百分比' ? '%' : ''
                y.push(item.unit)
            })
            series.sort(way.sortDbArrayData('total', 'descend'))
            y = [...new Set(y)]
            if (y.length === 2) {
                result.yaxislist.forEach((item, index) => {
                    if (item.unit === y[1]) {
                        series.splice(index, 1, {
                            name: item.name,
                            type: item.gpType,
                            data: item.value,
                            yAxis: 1,
                        })
                    }
                })
            }
            y.forEach((item, index) => {
                yAxis.push({
                    labels: {
                        formatter: function () {
                            return item === '百分比'
                                ? `${this.value} %`
                                : `${this.value}`
                        },
                        style: {
                            color: Highcharts.getOptions().colors[index],
                        },
                    },
                    title: {
                        text: item,
                        style: {
                            color: Highcharts.getOptions().colors[index],
                        },
                    },
                    opposite: !!index,
                })
            })
            return {
                xAxis: {
                    minPadding: 0,
                    startOnTick: false,
                    endOnTick: false,
                    value: result.xaxis,
                    labels: {
                        formatter: function () {
                            let labelVal = result.xaxis[this.value]
                            let reallyVal = labelVal
                            if (reallyVal.length > 10) {
                                reallyVal = labelVal.substr(0, 10) + '...'
                            }
                            return `<a title = ${labelVal}>${reallyVal}</a>`
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    },
                    crosshair: {
                        width: 1,
                        color: '#c7d8e6',
                        dashStyle: 'Solid',
                    },
                    tickInterval:
                        result.xaxis.length <= 7
                            ? 1
                            : Math.floor(result.xaxis.length / 6),
                },
                series: series,
                yAxis: yAxis,
                util: util,
            }
        }
    } else {
        return {}
    }
}
// 桑基图
let setSangKey = (result) => {
    let a = result.data.data
    return a
}
// 漏斗图
let setFunnel = (result) => {
    let a = result.data.data
    return a
}

// 词云图
let setWordscloud = (params) => {
    var text =
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean bibendum erat ac justo sollicitudin, quis lacinia ligula fringilla. Pellentesque hendrerit, nisi vitae posuere condimentum, lectus urna accumsan libero, rutrum commodo mi lacus pretium erat. Phasellus pretium ultrices mi sed semper. Praesent ut tristique magna. Donec nisl tellus, sagittis ut tempus sit amet, consectetur eget erat. Sed ornare gravida lacinia. Curabitur iaculis metus purus, eget pretium est laoreet ut. Quisque tristique augue ac eros malesuada, vitae facilisis mauris sollicitudin. Mauris ac molestie nulla, vitae facilisis quam. Curabitur placerat ornare sem, in mattis purus posuere eget. Praesent non condimentum odio. Nunc aliquet, odio nec auctor congue, sapien justo dictum massa, nec fermentum massa sapien non tellus. Praesent luctus eros et nunc pretium hendrerit. In consequat et eros nec interdum. Ut neque dui, maximus id elit ac, consequat pretium tellus. Nullam vel accumsan lorem.'
    return text
}

let chartParams = (params) => {
    let _p = {}
    if (params.compareType && params.indicatorIDs.length === 2) {
        _p = Object.assign({}, params, {
            indicatorIDs: [params.indicatorIDs[1]],
        })
    } else {
        _p = params
    }
    return _p
}

let changeParams = (show, params, title, contrast) => {
    show.forEach((item, index) => {
        switch (index) {
            case 0:
                if (!item && !(show[14] || show[13] || show[15] || show[17] || show[16])) {
                    delete params.endTime
                    delete params.startTime
                }
                break
            case 1:
                if(!item && !(show[18])){
                    delete params.storeID
                }
                break
            case 2:
                if (!item) delete params.isOld
                break
            case 3:
                if (!item) delete params.customerType
                break
            case 4:
                if (!item && !show[5]) {
                    delete params.bookSource
                }
                break
            case 6:
                if (!item) {
                    delete params.categoryID
                    delete params.prodID
                }
                break
            case 7:
                if (!item) {
                    delete params.miniPrice
                    delete params.maxPrice
                }
                break
            case 8:
                if (!item && !show[10]) delete params.status
                break
            case 11:
                if (!item) delete params.custSource
                break
            case 12:
                if (!item && !show[13]) delete params.discountCategory
                break
            case 14:
                if (!item) delete params.dimensionStatus
                break
            case 15:
                // LE-5997 国际特征（人群）筛选：仅人群销售趋势页展示，其它页面剥离，避免 query_common 跨页残留
                if (!item) delete params.intlFeatures
                break
            default:
                break
        }
    })
    if (title !== '日期') {
        delete params.dateFormat
    }
    if (!contrast) {
        delete params.comParamName
        delete params.compareParam
        delete params.paramName
    }
    if (params.constantKey === '') {
        delete params.constantKey
    }
    if (params.type === 0) {
        delete params.type
    }
}
let changeTrendParams = (params) => {
    delete params.ascending
    delete params.headerType
    delete params.parentID
    delete params.sortIndex
    delete params.pageNum
    delete params.pageSize
    delete params.dateFormat
    delete params.identifyKey
}
let changeIndexParams = (params) => {
    delete params.ascending
    delete params.constantKey
    delete params.headerType
    delete params.parentID
    delete params.sortIndex
    delete params.pageNum
    delete params.pageSize
    delete params.dateFormat
    delete params.byWhichWay
}

//递归判断对象内的key是否为空数据 当key有值时返回该对象，否则返回null
const filterEmptyObject = (obj) => {
    if (!obj || typeof obj !== "object") return null;

    const hasValue = (value) => {
      if (Array.isArray(value)) {
        return value.some(item => hasValue(item)); // 数组里只要有一个非空
      }
      if (value && typeof value === "object") {
        return Object.values(value).some(v => hasValue(v)); // 递归检查对象
      }
      return value !== null && value !== undefined && value !== "";
    };

    return hasValue(obj) ? obj : null;
  };

export {
    filterType,
    removeDataNull,
    setQuery,
    setQueryTable,
    getQueryAll,
    setQueryCustomer,
    setQueryPassFlow,
    setApiDataToTable,
    setApiCompareToTable,
    setApiDataToTableCommon,
    setApiNormalToTable,
    setTwoSerise,
    setCloumn,
    setPieSerise,
    setTrendSerise,
    setTrendColumn,
    chartParams,
    setSangKey,
    setWordscloud,
    setFunnel,
    changeParams,
    changeIndexParams,
    changeTrendParams,
    setApiDataTonoDemesion,
    filterEmptyObject
}
